import { ExclamationCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

import {
  Modal as ModalAnt,
  Form as FormAnt,
  Row as RowAnt,
  Col as ColAnt,
  Button,
} from "antd";

export const Modal = styled(ModalAnt)`
  padding-bottom: 0;
`;

export const Warning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
  margin-bottom: 1rem;
  background: var(--orange-50, #fff7ed);
  border: 1px solid var(--orange-100);
  border-radius: 5px;
  font-size: 0.8rem;
  color: var(--gray-900);
  line-height: 1.35;

  > .anticon {
    color: var(--orange-100);
    margin-top: 0.15rem;
    font-size: 1rem;
  }

  p {
    margin: 0;
  }

  ul {
    margin: 0.35rem 0 0;
    padding-left: 1.1rem;
  }

  li + li {
    margin-top: 0.25rem;
  }
`;

export const StepForm = styled.div`
  max-height: 20rem;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.5rem;

  ::-webkit-scrollbar {
    width: 8px !important;
    height: 6px !important;
    background-color: #f1f1f1 !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888 !important;
    border-radius: 2px !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555 !important;
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1 !important;
    border-radius: 2px !important;
  }
`;

export const CancelButton = styled(Button)`
  background: none;
  color: var(--gray-900);
  font-weight: 500;

  :hover,
  :focus,
  :active {
    background: none;
    color: var(--gray-900);
  }
`;

export const SaveButton = styled(Button)`
  background: var(--orange-100);
  color: var(--white);
  border-radius: 5px;

  :hover,
  :focus,
  :active {
    background: var(--orange-100);
    color: var(--white);
  }
`;

export const Form = styled(FormAnt)`
  .ant-input,
  .ant-input-number,
  .ant-select-selector {
    width: 100%;
    height: 3rem !important;
    border: 1px solid var(--gray-100);
    border-radius: 5px;
    outline: none;
    box-shadow: 0 0 0 0;
    display: flex;
    align-items: center;
  }

  .ant-input-number-input {
    height: 100% !important;
    text-align: center;
  }

  .ant-input-number-handler-wrap {
    display: none !important;
  }

  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  .ant-form-item {
    margin-bottom: 0;
    position: relative;
  }

  .ant-form-item-explain,
  .ant-form-item-explain-error {
    position: absolute;
    top: 100%;
    left: 0.25rem;
    font-size: 0.65rem;
    line-height: 1;
    white-space: nowrap;
    min-height: auto;
  }

  @media only screen and (max-width: 1366px) {
    .ant-input,
    .ant-input-number,
    .ant-select-selector {
      height: 2.3rem !important;
      font-size: 0.8rem;
    }

    .ant-form-item-explain.ant-form-item-explain-error {
      font-size: 0.7rem;
    }
  }
`;

export const Row = styled(RowAnt)`
  display: flex;
  width: 100%;
`;

export const Col = styled(ColAnt)``;

export const DefaultInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.8rem;
  color: var(--gray-550);

  strong {
    color: var(--gray-900);
    font-weight: 600;
  }

  .ant-skeleton-input {
    min-width: 2.5rem;
    width: 2.5rem;
    height: 0.9rem;
    border-radius: 4px;
    vertical-align: middle;
  }
`;

export const DefaultBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.1rem 0.45rem;
  background: var(--orange-50, #fff7ed);
  border: 1px solid var(--orange-100);
  border-radius: 4px;
  color: var(--orange-100);
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const SeriesHeaderRow = styled(Row)`
  padding: 0 0 0.5rem;
  margin-bottom: 0.25rem;
  border-bottom: 1px solid var(--gray-100);
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--gray-550);
`;

export const SeriesRow = styled(Row)<{ $changed?: boolean }>`
  padding: 0.6rem 0;
  border-bottom: 1px solid var(--gray-100);
  border-radius: 4px;
  transition: background 0.15s ease;
  background: ${({ $changed }) =>
    $changed ? "var(--orange-50, #fff7ed)" : "transparent"};

  :last-child {
    border-bottom: none;
  }

  .ant-skeleton-input {
    min-width: 2.5rem;
    width: 2.5rem;
    height: 0.9rem;
    border-radius: 4px;
    vertical-align: middle;
  }
`;

export const SeriesLabel = styled.span`
  font-weight: 500;
  color: var(--gray-550);

  @media only screen and (max-width: 1366px) {
    font-size: 0.8rem;
  }
`;

export const CurrentValue = styled.span<{ $empty?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: ${({ $empty }) => ($empty ? 400 : 500)};
  color: ${({ $empty }) => ($empty ? "var(--gray-100)" : "var(--gray-550)")};

  @media only screen and (max-width: 1366px) {
    font-size: 0.8rem;
  }
`;

export const ConfirmIcon = styled(ExclamationCircleOutlined)`
  color: var(--orange-100);
`;

export const ChannelBlock = styled.div`
  padding-left: 0.6rem;
  border-left: 3px solid var(--orange-100);
`;

export const ChannelName = styled.div`
  font-weight: 600;
`;

export const ConfirmField = styled.div`
  margin-top: 0.35rem;
`;

export const FieldLabel = styled.div`
  font-weight: 500;
`;

export const ChangedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.75rem;
  max-height: 18rem;
  overflow-y: auto;
  padding-right: 0.5rem;

  ::-webkit-scrollbar {
    width: 8px !important;
    height: 6px !important;
    background-color: #f1f1f1 !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888 !important;
    border-radius: 2px !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555 !important;
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1 !important;
    border-radius: 2px !important;
  }
`;
